import {
    MapPin,
    Mail,
    Phone,
    Facebook,
    Linkedin,
} from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
    return (
        <footer
            className="bg-[#0a0a0f] text-white border-t border-[#62688C] relative"
            id="site-footer"
        >
            <div className="max-w-7xl mx-auto px-6 py-12">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-10">
                    {/* Column 1 */}
                    <div>
                        <h4 className="bg-gradient-to-br from-purple-500 to-cyan-500 bg-clip-text text-transparent mb-4 font-bold text-lg">Digital Services</h4>
                        <ul className="space-y-2">
                            <li><Link to="/ai-solutions">AI Solutions</Link></li>
                            <li><Link to="/marketing">SEO & Digital Marketing</Link></li>
                            <li><Link to="/ui-ux-design">UI/UX Design</Link></li>
                            <li><Link to="/e-commerce-solutions">E-commerce Solutions</Link></li>
                            <li><Link to="/application-development">Application Development</Link></li>
                        </ul>
                    </div>

                    {/* Column 2 */}
                    <div>
                        <h4 className="bg-gradient-to-br from-purple-500 to-cyan-500 bg-clip-text text-transparent mb-4 font-bold text-lg">Infrastructure Services</h4>
                        <ul className="space-y-2">
                            <li><Link to="/it-service-package">IT Infrastructure Management</Link></li>
                            <li><Link to="/cloud-solutions">Cloud Solutions</Link></li>
                            <li><Link to="/domains">Web Hosting & Domain</Link></li>
                            <li><Link to="/voip-service">VoIP Service</Link></li>
                            <li><Link to="/cybersecurity-services">Cybersecurity Services</Link></li>
                        </ul>
                    </div>

                    {/* Column 3 */}
                    <div>
                        <h4 className="bg-gradient-to-br from-purple-500 to-cyan-500 bg-clip-text text-transparent mb-4 font-bold text-lg">Other Links</h4>
                        <ul className="space-y-2">
                            <li><Link to="/about">About Us</Link></li>
                            <li><Link to="/newsroom">Newsroom</Link></li>
                            <li><Link to="/careers">Career</Link></li>
                            <li><Link to="/support">Support</Link></li>
                            <li><Link to="/privacy-policy">Privacy</Link></li>
                            <li><Link to="/term-and-condition">Terms</Link></li>
                            <li><Link to="/contact-us">Contact Us</Link></li>
                        </ul>
                    </div>

                    {/* Column 4 - Contact */}
                    <div className="lg:col-span-1">
                        <div className="mb-6">
                            <h4 className="bg-gradient-to-br from-purple-500 to-cyan-500 bg-clip-text text-transparent mb-4 font-bold text-lg">Contact</h4>
                            <ul className="space-y-3">
                                <li className="flex items-center gap-3">
                                    <MapPin size={16} />
                                    <span>Melbourne, Australia</span>
                                </li>
                                <li className="flex items-center gap-3">
                                    <Mail size={16} />
                                    <a href="mailto:enquiries@sanmicron.com" className="hover:text-cyan-400 transition-colors">
                                        enquiries@sanmicron.com
                                    </a>
                                </li>
                                <li className="flex items-center gap-3">
                                    <Phone size={16} />
                                    <a href="tel:+61391167215" className="hover:text-cyan-400 transition-colors">
                                        +61 391 167 215
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <h4 className="bg-gradient-to-br from-purple-500 to-cyan-500 bg-clip-text text-transparent mb-4 font-bold text-lg">Our Locations</h4>
                        <span>Australia , New Zealand , Japan , USA , Nepal</span>
                    </div>
                </div>
            </div>

            {/* Bottom Bar */}
            <div className="border-t border-[#62688C]">
                <div className="max-w-7xl mx-auto px-6 py-6 grid grid-cols-1 md:grid-cols-[2fr_1fr] gap-10">
                    <p className="text-white text-sm">
                        © {new Date().getFullYear()} SAN micron PTY LTD | All Rights Reserved
                    </p>
                    <div className="flex gap-6 text-lg md:justify-center">
                        <a href="https://www.facebook.com/p/SAN-micron-61569088162671/" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400">
                            <Facebook />
                        </a>
                        <a href="https://www.linkedin.com/company/sanmicron/life" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400">
                            <Linkedin />
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
}